export default __webpack_public_path__ + "fe3739027e4cc8e5bcc1c91032a4a401.svg";